var render = function render(){
  var _vm$$master$deliveryF, _vm$$master;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container-wrapper"
  }, [_c('div', {
    staticClass: "container-wrap"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v("Delivery Conditions")]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(0), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.name,
      expression: "body.name"
    }],
    staticClass: "input-container",
    staticStyle: {
      "background": "var(--white)",
      "padding": "10px 15px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Input Name..."
    },
    domProps: {
      "value": _vm.body.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "name", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(1), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.description,
      expression: "body.description"
    }],
    attrs: {
      "placeholder": "Description",
      "rows": "5"
    },
    domProps: {
      "value": _vm.body.description
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "description", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(2), _c('div', {
    staticClass: "flex-link"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_c('radio', {
    attrs: {
      "options": ['active'],
      "label": "Active"
    },
    model: {
      value: _vm.body.status,
      callback: function ($$v) {
        _vm.$set(_vm.body, "status", $$v);
      },
      expression: "body.status"
    }
  })], 1), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_c('radio', {
    attrs: {
      "options": ['inactive'],
      "label": "Inactive"
    },
    model: {
      value: _vm.body.status,
      callback: function ($$v) {
        _vm.$set(_vm.body, "status", $$v);
      },
      expression: "body.status"
    }
  })], 1)])])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._m(3), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(4), _c('div', [_c('multiselect', {
    attrs: {
      "options": (_vm$$master$deliveryF = (_vm$$master = _vm.$master) === null || _vm$$master === void 0 ? void 0 : _vm$$master.deliveryFeeDistricts) !== null && _vm$$master$deliveryF !== void 0 ? _vm$$master$deliveryF : [],
      "label": "districtName",
      "track-by": "districtId",
      "multiple": true,
      "taggable": true,
      "placeholder": "Search District",
      "open-direction": "bottom",
      "show-no-results": false,
      "internal-search": true,
      "clear-on-select": false,
      "close-on-select": false,
      "options-limit": 100
    },
    model: {
      value: _vm.body.districtIds,
      callback: function ($$v) {
        _vm.$set(_vm.body, "districtIds", $$v);
      },
      expression: "body.districtIds"
    }
  })], 1)])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._m(5), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(6), _c('div', {
    staticClass: "flex-link"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.customerGroupAction,
      expression: "body.customerGroupAction"
    }],
    staticStyle: {
      "padding": "9px 10px"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "customerGroupAction", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.actions, function (action, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": action.id
      }
    }, [_vm._v(" " + _vm._s(action.name) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "row"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.customerGroupOptions,
      "label": "displayName",
      "track-by": "id",
      "multiple": true,
      "taggable": true,
      "loading": _vm.loading.isSearching,
      "placeholder": "Search Customer Group",
      "open-direction": "bottom",
      "show-no-results": false,
      "internal-search": false,
      "clear-on-select": false,
      "close-on-select": false,
      "options-limit": 100
    },
    on: {
      "search-change": _vm.debouncedOnSearchCustomerGroups
    },
    model: {
      value: _vm.body.customerGroupIds,
      callback: function ($$v) {
        _vm.$set(_vm.body, "customerGroupIds", $$v);
      },
      expression: "body.customerGroupIds"
    }
  })], 1)])]), _c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(7), _c('div', {
    staticClass: "flex-link"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.customerAction,
      expression: "body.customerAction"
    }],
    staticStyle: {
      "padding": "9px 10px"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "customerAction", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.actions, function (action, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": action.id
      }
    }, [_vm._v(" " + _vm._s(action.name) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "row"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.customerOptions,
      "label": "displayName",
      "track-by": "id",
      "multiple": true,
      "taggable": true,
      "loading": _vm.loading.isSearching,
      "placeholder": "Search Customer",
      "open-direction": "bottom",
      "show-no-results": false,
      "internal-search": false,
      "clear-on-select": false,
      "close-on-select": false,
      "options-limit": 100
    },
    on: {
      "search-change": _vm.debouncedOnSearchCustomers
    },
    model: {
      value: _vm.body.customerIds,
      callback: function ($$v) {
        _vm.$set(_vm.body, "customerIds", $$v);
      },
      expression: "body.customerIds"
    }
  })], 1)])])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._m(8), _c('div', {
    staticClass: "content-item"
  }, _vm._l(_vm.standardDeliveryFeeTypes, function (item) {
    return _c('div', {
      staticClass: "split-item-link"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "fit-content"
      }
    }, [_c('radio', {
      attrs: {
        "options": [item === null || item === void 0 ? void 0 : item.id],
        "label": item === null || item === void 0 ? void 0 : item.name
      },
      on: {
        "onchange": _vm.onChangeStandard
      },
      model: {
        value: _vm.body.type,
        callback: function ($$v) {
          _vm.$set(_vm.body, "type", $$v);
        },
        expression: "body.type"
      }
    })], 1), _vm.body.type === 'fixed amount' && item.id === 'fixed amount' ? _c('div', {
      staticClass: "flex-price-input",
      staticStyle: {
        "margin-top": "5px",
        "padding-left": "28px"
      }
    }, [_c('span', {
      staticClass: "flex-price-input-icon"
    }, [_vm._v(" $ ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.body.baseDeliveryFee,
        expression: "body.baseDeliveryFee",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "padding": "8px 15px",
        "z-index": "1",
        "height": "100%"
      },
      attrs: {
        "type": "number",
        "placeholder": "0.00"
      },
      domProps: {
        "value": _vm.body.baseDeliveryFee
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.body, "baseDeliveryFee", _vm._n($event.target.value));
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    })]) : _vm._e(), _vm.body.type === 'condition' && item.id === 'condition' ? _c('div', {
      staticClass: "form-tab-item",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticClass: "form-tab-item-header"
    }, [_vm._v("Setup Condition")]), _c('div', {
      staticClass: "form-tab-item-content"
    }, [_c('div', {
      staticClass: "form-tab-item-row mb15"
    }, [_c('span', [_vm._v("Basic Distance")]), _c('div', {
      staticClass: "form-tab-item-row-link mt5"
    }, [_vm._m(9, true), _c('div', {
      staticClass: "form-tab-item-row-link-header"
    }, [_c('span', {
      staticClass: "header-right"
    }, [_c('div', {
      staticClass: "flex-price-input"
    }, [_c('span', {
      staticClass: "flex-price-input-icon"
    }, [_vm._v(" Km ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.body.basicDistanceKm,
        expression: "body.basicDistanceKm",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "padding": "8px 15px",
        "z-index": "1",
        "height": "100%"
      },
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": _vm.body.basicDistanceKm
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.body, "basicDistanceKm", _vm._n($event.target.value));
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    })])]), _c('span', {
      staticClass: "header-arrow"
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 13 13",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M11.75 6.48926H1.25M11.75 6.48926L6.5 11.7393M11.75 6.48926L6.5 1.23926",
        "stroke": "#646669",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    })])]), _c('span', {
      staticClass: "header-left"
    }, [_c('div', {
      staticClass: "flex-price-input"
    }, [_c('span', {
      staticClass: "flex-price-input-icon"
    }, [_vm._v(" $ ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.body.basicDistanceFee,
        expression: "body.basicDistanceFee",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "padding": "8px 15px",
        "z-index": "1",
        "height": "100%"
      },
      attrs: {
        "type": "number",
        "placeholder": "0.00"
      },
      domProps: {
        "value": _vm.body.basicDistanceFee
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.body, "basicDistanceFee", _vm._n($event.target.value));
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    })])])])])]), _c('div', {
      staticClass: "form-tab-item-row"
    }, [_c('span', [_vm._v("Extended Distance")]), _c('div', {
      staticClass: "form-tab-item-row-link mt5"
    }, [_vm._m(10, true), _vm._l(_vm.body.conditions, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "form-tab-item-row-link-header list-action"
      }, [_c('span', {
        staticClass: "header-right"
      }, [_c('div', {
        staticClass: "header-right-item"
      }, [_c('span', {
        staticClass: "header-right-item-link"
      }, [_c('div', {
        staticClass: "flex-price-input"
      }, [_c('span', {
        staticClass: "flex-price-input-icon"
      }, [_vm._v(" Km ")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: item.extendMinKm,
          expression: "item.extendMinKm",
          modifiers: {
            "number": true
          }
        }],
        staticStyle: {
          "padding": "8px 15px",
          "z-index": "1",
          "height": "100%"
        },
        attrs: {
          "type": "number",
          "placeholder": "0"
        },
        domProps: {
          "value": item.extendMinKm
        },
        on: {
          "input": function ($event) {
            if ($event.target.composing) return;
            _vm.$set(item, "extendMinKm", _vm._n($event.target.value));
          },
          "blur": function ($event) {
            return _vm.$forceUpdate();
          }
        }
      })])]), _c('span', {
        staticClass: "header-right-item-link"
      }, [_c('div', {
        staticClass: "flex-price-input"
      }, [_c('span', {
        staticClass: "flex-price-input-icon"
      }, [_vm._v(" Km ")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: item.extendMaxKm,
          expression: "item.extendMaxKm",
          modifiers: {
            "number": true
          }
        }],
        staticStyle: {
          "padding": "8px 15px",
          "z-index": "1",
          "height": "100%"
        },
        attrs: {
          "type": "number",
          "placeholder": "0"
        },
        domProps: {
          "value": item.extendMaxKm
        },
        on: {
          "input": function ($event) {
            if ($event.target.composing) return;
            _vm.$set(item, "extendMaxKm", _vm._n($event.target.value));
          },
          "blur": function ($event) {
            return _vm.$forceUpdate();
          }
        }
      })])])])]), _c('span', {
        staticClass: "header-arrow"
      }, [_c('svg', {
        attrs: {
          "width": "13",
          "height": "13",
          "viewBox": "0 0 13 13",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M11.75 6.48926H1.25M11.75 6.48926L6.5 11.7393M11.75 6.48926L6.5 1.23926",
          "stroke": "#646669",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })])]), _c('span', {
        staticClass: "header-left"
      }, [_c('div', {
        staticClass: "header-left-item"
      }, [_c('div', {
        staticClass: "flex-price-input"
      }, [_c('span', {
        staticClass: "flex-price-input-icon"
      }, [_vm._v(" $ ")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: item.feePerKm,
          expression: "item.feePerKm",
          modifiers: {
            "number": true
          }
        }],
        staticStyle: {
          "padding": "8px 15px",
          "z-index": "1",
          "height": "100%"
        },
        attrs: {
          "type": "number",
          "placeholder": "0.00"
        },
        domProps: {
          "value": item.feePerKm
        },
        on: {
          "input": function ($event) {
            if ($event.target.composing) return;
            _vm.$set(item, "feePerKm", _vm._n($event.target.value));
          },
          "blur": function ($event) {
            return _vm.$forceUpdate();
          }
        }
      })]), _c('div', {
        staticClass: "header-left-item-action"
      }, [index === 0 ? _c('svg', {
        staticStyle: {
          "opacity": "0.6",
          "cursor": "not-allowed"
        },
        attrs: {
          "width": "20",
          "height": "19",
          "viewBox": "0 0 20 19",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M8.16666 3.98942H11.8333C11.8333 3.50319 11.6402 3.03687 11.2964 2.69306C10.9525 2.34924 10.4862 2.15609 10 2.15609C9.51377 2.15609 9.04745 2.34924 8.70364 2.69306C8.35982 3.03687 8.16666 3.50319 8.16666 3.98942ZM6.33333 3.98942C6.33333 3.01696 6.71964 2.08433 7.40727 1.3967C8.09491 0.709062 9.02754 0.322754 10 0.322754C10.9725 0.322754 11.9051 0.709062 12.5927 1.3967C13.2804 2.08433 13.6667 3.01696 13.6667 3.98942H18.25C18.4931 3.98942 18.7263 4.086 18.8982 4.25791C19.0701 4.42981 19.1667 4.66297 19.1667 4.90609C19.1667 5.1492 19.0701 5.38236 18.8982 5.55427C18.7263 5.72618 18.4931 5.82275 18.25 5.82275H17.4415L16.6293 15.3011C16.5513 16.2163 16.1325 17.069 15.4559 17.6902C14.7792 18.3115 13.8941 18.6562 12.9755 18.6561H7.0245C6.10592 18.6562 5.22075 18.3115 4.54414 17.6902C3.86752 17.069 3.44874 16.2163 3.37067 15.3011L2.5585 5.82275H1.75C1.50688 5.82275 1.27373 5.72618 1.10182 5.55427C0.929909 5.38236 0.833332 5.1492 0.833332 4.90609C0.833332 4.66297 0.929909 4.42981 1.10182 4.25791C1.27373 4.086 1.50688 3.98942 1.75 3.98942H6.33333ZM12.75 9.48942C12.75 9.2463 12.6534 9.01315 12.4815 8.84124C12.3096 8.66933 12.0764 8.57275 11.8333 8.57275C11.5902 8.57275 11.3571 8.66933 11.1852 8.84124C11.0132 9.01315 10.9167 9.2463 10.9167 9.48942V13.1561C10.9167 13.3992 11.0132 13.6324 11.1852 13.8043C11.3571 13.9762 11.5902 14.0728 11.8333 14.0728C12.0764 14.0728 12.3096 13.9762 12.4815 13.8043C12.6534 13.6324 12.75 13.3992 12.75 13.1561V9.48942ZM8.16666 8.57275C8.40978 8.57275 8.64294 8.66933 8.81485 8.84124C8.98675 9.01315 9.08333 9.2463 9.08333 9.48942V13.1561C9.08333 13.3992 8.98675 13.6324 8.81485 13.8043C8.64294 13.9762 8.40978 14.0728 8.16666 14.0728C7.92355 14.0728 7.69039 13.9762 7.51848 13.8043C7.34658 13.6324 7.25 13.3992 7.25 13.1561V9.48942C7.25 9.2463 7.34658 9.01315 7.51848 8.84124C7.69039 8.66933 7.92355 8.57275 8.16666 8.57275ZM5.19667 15.1453C5.23572 15.603 5.44524 16.0295 5.78374 16.3401C6.12224 16.6508 6.56505 16.823 7.0245 16.8228H12.9755C13.4346 16.8226 13.877 16.6501 14.2151 16.3395C14.5532 16.0289 14.7625 15.6027 14.8015 15.1453L15.6008 5.82275H4.39917L5.19667 15.1453Z",
          "fill": "#F91E1E"
        }
      })]) : _c('svg', {
        attrs: {
          "width": "20",
          "height": "19",
          "viewBox": "0 0 20 19",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.onDeleteAction(index);
          }
        }
      }, [_c('path', {
        attrs: {
          "d": "M8.16666 3.98942H11.8333C11.8333 3.50319 11.6402 3.03687 11.2964 2.69306C10.9525 2.34924 10.4862 2.15609 10 2.15609C9.51377 2.15609 9.04745 2.34924 8.70364 2.69306C8.35982 3.03687 8.16666 3.50319 8.16666 3.98942ZM6.33333 3.98942C6.33333 3.01696 6.71964 2.08433 7.40727 1.3967C8.09491 0.709062 9.02754 0.322754 10 0.322754C10.9725 0.322754 11.9051 0.709062 12.5927 1.3967C13.2804 2.08433 13.6667 3.01696 13.6667 3.98942H18.25C18.4931 3.98942 18.7263 4.086 18.8982 4.25791C19.0701 4.42981 19.1667 4.66297 19.1667 4.90609C19.1667 5.1492 19.0701 5.38236 18.8982 5.55427C18.7263 5.72618 18.4931 5.82275 18.25 5.82275H17.4415L16.6293 15.3011C16.5513 16.2163 16.1325 17.069 15.4559 17.6902C14.7792 18.3115 13.8941 18.6562 12.9755 18.6561H7.0245C6.10592 18.6562 5.22075 18.3115 4.54414 17.6902C3.86752 17.069 3.44874 16.2163 3.37067 15.3011L2.5585 5.82275H1.75C1.50688 5.82275 1.27373 5.72618 1.10182 5.55427C0.929909 5.38236 0.833332 5.1492 0.833332 4.90609C0.833332 4.66297 0.929909 4.42981 1.10182 4.25791C1.27373 4.086 1.50688 3.98942 1.75 3.98942H6.33333ZM12.75 9.48942C12.75 9.2463 12.6534 9.01315 12.4815 8.84124C12.3096 8.66933 12.0764 8.57275 11.8333 8.57275C11.5902 8.57275 11.3571 8.66933 11.1852 8.84124C11.0132 9.01315 10.9167 9.2463 10.9167 9.48942V13.1561C10.9167 13.3992 11.0132 13.6324 11.1852 13.8043C11.3571 13.9762 11.5902 14.0728 11.8333 14.0728C12.0764 14.0728 12.3096 13.9762 12.4815 13.8043C12.6534 13.6324 12.75 13.3992 12.75 13.1561V9.48942ZM8.16666 8.57275C8.40978 8.57275 8.64294 8.66933 8.81485 8.84124C8.98675 9.01315 9.08333 9.2463 9.08333 9.48942V13.1561C9.08333 13.3992 8.98675 13.6324 8.81485 13.8043C8.64294 13.9762 8.40978 14.0728 8.16666 14.0728C7.92355 14.0728 7.69039 13.9762 7.51848 13.8043C7.34658 13.6324 7.25 13.3992 7.25 13.1561V9.48942C7.25 9.2463 7.34658 9.01315 7.51848 8.84124C7.69039 8.66933 7.92355 8.57275 8.16666 8.57275ZM5.19667 15.1453C5.23572 15.603 5.44524 16.0295 5.78374 16.3401C6.12224 16.6508 6.56505 16.823 7.0245 16.8228H12.9755C13.4346 16.8226 13.877 16.6501 14.2151 16.3395C14.5532 16.0289 14.7625 15.6027 14.8015 15.1453L15.6008 5.82275H4.39917L5.19667 15.1453Z",
          "fill": "#F91E1E"
        }
      })]), index === _vm.body.conditions.length - 1 ? _c('svg', {
        attrs: {
          "width": "16",
          "height": "16",
          "viewBox": "0 0 16 16",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.onAddNewAction.apply(null, arguments);
          }
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M8 0.972656C8.60752 0.972656 9.1 1.46514 9.1 2.07266V7.38932H14.4167C15.0242 7.38932 15.5167 7.88181 15.5167 8.48932C15.5167 9.09684 15.0242 9.58932 14.4167 9.58932H9.1V14.906C9.1 15.5135 8.60752 16.006 8 16.006C7.39249 16.006 6.9 15.5135 6.9 14.906V9.58932H1.58334C0.975824 9.58932 0.483337 9.09684 0.483337 8.48932C0.483337 7.88181 0.975824 7.38932 1.58334 7.38932H6.9V2.07266C6.9 1.46514 7.39249 0.972656 8 0.972656Z",
          "fill": "#323232"
        }
      })]) : _c('svg', {
        attrs: {
          "width": "16",
          "height": "16",
          "viewBox": "0 0 16 16",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M8 0.972656C8.60752 0.972656 9.1 1.46514 9.1 2.07266V7.38932H14.4167C15.0242 7.38932 15.5167 7.88181 15.5167 8.48932C15.5167 9.09684 15.0242 9.58932 14.4167 9.58932H9.1V14.906C9.1 15.5135 8.60752 16.006 8 16.006C7.39249 16.006 6.9 15.5135 6.9 14.906V9.58932H1.58334C0.975824 9.58932 0.483337 9.09684 0.483337 8.48932C0.483337 7.88181 0.975824 7.38932 1.58334 7.38932H6.9V2.07266C6.9 1.46514 7.39249 0.972656 8 0.972656Z",
          "fill": "#323232",
          "fill-opacity": "0.4"
        }
      })])])])])]);
    })], 2)])]), _c('div', {
      staticClass: "form-tab-item-footer"
    }, [_c('div', {
      staticClass: "form-tab-item-footer-top"
    }, [_c('div', {
      staticClass: "title-item",
      staticStyle: {
        "display": "grid",
        "font-size": "15px"
      },
      style: !_vm.body.isFreeDeliveryOnMinOrderAmount ? 'margin-bottom: 0px' : ''
    }, [_c('span', [_c('checkbox', {
      attrs: {
        "label": "Free Delivery"
      },
      on: {
        "onchange": _vm.onChangeIsFree
      },
      model: {
        value: _vm.body.isFreeDeliveryOnMinOrderAmount,
        callback: function ($$v) {
          _vm.$set(_vm.body, "isFreeDeliveryOnMinOrderAmount", $$v);
        },
        expression: "body.isFreeDeliveryOnMinOrderAmount"
      }
    })], 1), _vm.body.isFreeDeliveryOnMinOrderAmount ? _c('small', {
      staticStyle: {
        "color": "#aeaeae",
        "font-size": "14px",
        "font-weight": "400",
        "margin-top": "3px"
      }
    }, [_vm._v(" Minimum order amount to get free delivery ")]) : _vm._e()])]), _vm.body.isFreeDeliveryOnMinOrderAmount ? _c('div', {
      staticClass: "form-tab-item-footer-bottom"
    }, [_c('div', {
      staticClass: "flex-price-input"
    }, [_c('span', {
      staticClass: "flex-price-input-icon"
    }, [_vm._v(" $ ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.body.freeDeliveryOnMinOrderAmount,
        expression: "body.freeDeliveryOnMinOrderAmount",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "padding": "8px 15px",
        "z-index": "1",
        "height": "100%"
      },
      attrs: {
        "type": "number",
        "placeholder": "0.00"
      },
      domProps: {
        "value": _vm.body.freeDeliveryOnMinOrderAmount
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.body, "freeDeliveryOnMinOrderAmount", _vm._n($event.target.value));
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    })])]) : _vm._e()])]) : _vm._e()]);
  }), 0)]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item",
    staticStyle: {
      "display": "grid"
    },
    style: !_vm.body.isExpressDelivery ? 'margin-bottom: 0px' : ''
  }, [_c('span', [_c('checkbox', {
    attrs: {
      "label": "Express Delivery Fee"
    },
    on: {
      "onchange": _vm.onChangeExpress
    },
    model: {
      value: _vm.body.isExpressDelivery,
      callback: function ($$v) {
        _vm.$set(_vm.body, "isExpressDelivery", $$v);
      },
      expression: "body.isExpressDelivery"
    }
  })], 1), _vm.body.isExpressDelivery ? _c('small', {
    staticStyle: {
      "color": "#aeaeae",
      "font-size": "14px",
      "font-weight": "400",
      "margin-top": "3px"
    }
  }, [_vm._v(" Express delivery fee will add up (+) to standard delivery fee with following amount ")]) : _vm._e()]), _vm.body.isExpressDelivery ? _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "split-item-link"
  }, [_c('div', {
    staticClass: "flex-link",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.expressDeliveryType,
      expression: "body.expressDeliveryType"
    }],
    staticStyle: {
      "padding": "9px 10px"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "expressDeliveryType", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.expressDeliveryTypes, function (action, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": action.id
      }
    }, [_vm._v(" " + _vm._s(action.name) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "flex-price-input"
  }, [_c('span', {
    staticClass: "flex-price-input-icon"
  }, [_vm._v(" " + _vm._s(_vm.body.expressDeliveryType === "fixed amount" ? "$" : "%") + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.body.expressDeliveryFee,
      expression: "body.expressDeliveryFee",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "padding": "8px 15px",
      "z-index": "1",
      "height": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.body.expressDeliveryFee
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "expressDeliveryFee", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])])]) : _vm._e()]), _c('div', {
    staticClass: "form-footer",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-secondary mr8",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" Cancel ")]), !_vm.isCreating ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Create ")]) : _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("Loading...")])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Condition Name")]), _c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Description")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Status")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "title-item",
    staticStyle: {
      "display": "grid"
    }
  }, [_c('span', [_vm._v("Delivery Location")]), _c('small', {
    staticStyle: {
      "color": "#aeaeae",
      "font-size": "14px",
      "font-weight": "400",
      "margin-top": "3px"
    }
  }, [_vm._v(" Choose district for this condition. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("District")]), _c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "title-item",
    staticStyle: {
      "display": "grid"
    }
  }, [_c('span', [_vm._v("Apply To Customer")]), _c('small', {
    staticStyle: {
      "color": "#aeaeae",
      "font-size": "14px",
      "font-weight": "400",
      "margin-top": "3px"
    }
  }, [_vm._v(" Choose customer for this condition. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Customer Group")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Specific Customer")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "title-item",
    staticStyle: {
      "display": "grid"
    }
  }, [_c('span', [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Standard Delivery Fee ")]), _c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-tab-item-row-link-header"
  }, [_c('span', {
    staticClass: "header-right"
  }, [_vm._v("Maximum Kilometer")]), _c('span', {
    staticClass: "header-arrow"
  }), _c('span', {
    staticClass: "header-left"
  }, [_vm._v("Fixed Fee")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-tab-item-row-link-header"
  }, [_c('span', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "header-right-item"
  }, [_c('span', {
    staticClass: "header-right-item-link"
  }, [_vm._v(" Min. Kilometer ")]), _c('span', {
    staticClass: "header-right-item-link"
  }, [_vm._v(" Max. Kilometer ")])])]), _c('span', {
    staticClass: "header-arrow"
  }), _c('span', {
    staticClass: "header-left"
  }, [_c('div', {
    staticClass: "header-left-item"
  }, [_vm._v("Fee per KM")])])]);

}]

export { render, staticRenderFns }